export default "__VITE_ASSET__fabff8dd__"